// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DC6R","index":"styles_index__7SXSS"};